import { createPinia, type Pinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

function createConsumerStore () {
  const pinia = createPinia()

  if (!import.meta.env.SSR)
    pinia.use(piniaPluginPersistedstate)

  return pinia
}

const consumerStore = import.meta.env.SSR
  ? undefined as any as Pinia
  : createConsumerStore()

export function getConsumerStore () {
  return import.meta.env.SSR ? createConsumerStore() : consumerStore
}
